import React from 'react';

const STYLES = {
  PAID: 'bg-emerald-50 text-emerald-700 ring-1 ring-inset ring-emerald-600/20',
  APPROVED: 'bg-amber-50 text-amber-700 ring-1 ring-inset ring-amber-600/20',
  DRAFT: 'bg-blue-50 text-blue-700 ring-1 ring-inset ring-blue-700/20',
  ERROR: 'bg-red-50 text-red-700 ring-1 ring-inset ring-red-600/20',
  Active: 'bg-emerald-50 text-emerald-700 ring-1 ring-inset ring-emerald-600/20',
  Archived: 'bg-slate-100 text-slate-600 ring-1 ring-inset ring-slate-600/20',
};

const DOTS = {
  PAID: 'bg-emerald-500',
  APPROVED: 'bg-amber-500',
  DRAFT: 'bg-blue-500',
  ERROR: 'bg-red-500',
  Active: 'bg-emerald-500',
  Archived: 'bg-slate-400',
};

export const StatusBadge = ({ status }) => {
  const style = STYLES[status] || STYLES.DRAFT;
  const dot = DOTS[status] || DOTS.DRAFT;
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-medium ${style}`} data-testid={`status-badge-${status}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${dot}`} />
      {status}
    </span>
  );
};
